<dialog-header
  >OTA Update: {{ data.displayName || 'Signage Stick Display' }}</dialog-header
>

<mat-dialog-content class="ota-update-content">
  <!-- Amazon Signage Stick Logo -->
  <div class="logo-container">
    <img
      src="/images/install/amazonsignagestick.png"
      alt="Amazon Signage Stick"
      class="signage-stick-logo-image"
    />
  </div>

  <!-- Supporting Text -->
  <div class="supporting-text">
    The Signage Stick will download and install the latest available
    over-the-air update. The content showing on your display will be
    interrupted. Do you wish to proceed?
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="tw-gap-4">
  <div class="tw-flex-1">
    <button
      rv-button
      variant="secondary"
      type="button"
      class="tw-w-full"
      (click)="onCancel()"
    >
      Cancel
    </button>
  </div>
  <div class="tw-flex-1">
    <button rv-button type="button" class="tw-w-full" (click)="onUpdate()">
      OTA Update
    </button>
  </div>
</mat-dialog-actions>
